import PropTypes from "prop-types";
import React, { useEffect, useState, useMemo } from "react";
import { Message } from "semantic-ui-react";

const AppNotification = ({ children, timeout = 10000, isError = false, onDismiss }) => {
  const [open, setOpen] = useState(false);

  const isEffectivelyEmpty = React.Children.toArray(children).every(
    (child) =>
      child === null || child === undefined || child === false || (typeof child === "string" && child.trim() === ""),
  );

  const contentKey = useMemo(() => {
    if (isEffectivelyEmpty) return "";
    if (typeof children === "string") return children;
    try {
      return JSON.stringify(children);
    } catch {
      return String(children);
    }
  }, [children, isEffectivelyEmpty]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: Re-run effect when contentKey changes
  useEffect(() => {
    if (isEffectivelyEmpty) {
      setOpen(false);
      return;
    }

    setOpen(true);

    const timer = setTimeout(() => {
      setOpen(false);
      if (onDismiss) onDismiss();
    }, timeout);

    return () => clearTimeout(timer);
  }, [contentKey, isEffectivelyEmpty, timeout, onDismiss]);

  const handleDismiss = () => {
    setOpen(false);
    if (onDismiss) onDismiss();
  };

  if (!open) return null;

  return (
    <Message
      error={isError}
      success={!isError}
      className="page-success-message"
      attached
      onDismiss={handleDismiss}
    >
      {children}
    </Message>
  );
};

AppNotification.propTypes = {
  children: PropTypes.node,
  timeout: PropTypes.number,
  isError: PropTypes.bool,
  onDismiss: PropTypes.func,
};

export default AppNotification;
